import useIsUserInJupyterPage from './useIsUserInJupyterPage';

export default useIsUserInJupyterPage;
